"use strict";
import React from "react";
import { Link } from "react-router-dom";

const initComponent = (flex = window.flex) => {

    class OpsNav extends React.Component {
        constructor() {
            super();
            this.megaMenu = React.createRef();
        }
        toggleSidebar = () => {
            if(this.props.toggleSidebar){
                this.props.toggleSidebar();
            }
        };
        hideNav = () => {
            if(this.props.hideNavBar){
                this.props.hideNavBar();
            }
        };
        render() {
            const appContext = this.props.appContext;
            const navItems = flex.getNavsByPosition(appContext, "Ops");
            const navLinks = navItems.map((navItem, index) => {
                return (
                    <li key={index}>
                        <Link to={navItem.link} title={flex.text(navItem.titleKey, navItem.title)} onClick={this.hideNav}>
                            {/*<i className="fa fa-diamond"></i> */}
                            <span className="nav-label">{flex.text(navItem.labelKey, navItem.label)}</span>
                        </Link>
                    </li>
                )
            });
            return (
                <nav className="navbar-default navbar-static-side" role="navigation" ref={this.megaMenu} onClick={this.handleOutsideClick}>
                    <div className="sidebar-collapse">
                        <ul className="nav metismenu" id="side-menu">
                            <div className="sidebar-collapse__nav-close" onClick={this.hideNav}>
                                <span>x</span>
                            </div>
                            <li className="nav-header">
                                <h1>Ops</h1>
                            </li>
                            {screen.width <= 1368 ? 
                                <div className="nav-menu-item">
                                    {navLinks}
                                </div> : <>{navLinks}</>}
                            {/*<li>
									    <a><i className="fa fa-bar-chart-o"></i> <span className="nav-label">Graphs</span><span className="fa arrow"></span></a>
									    <ul className="nav nav-second-level collapse">
										    <li><a href="graph_flot.html">Flot Charts</a></li>
										    <li><a href="graph_morris.html">Morris.js Charts</a></li>
										    <li><a href="graph_rickshaw.html">Rickshaw Charts</a></li>
										    <li><a href="graph_chartjs.html">Chart.js</a></li>
										    <li><a href="graph_chartist.html">Chartist</a></li>
										    <li><a href="c3.html">c3 charts</a></li>
										    <li><a href="graph_peity.html">Peity Charts</a></li>
										    <li><a href="graph_sparkline.html">Sparkline Charts</a></li>
									    </ul>
								    </li>*/}
                        </ul>

                    </div>
                </nav>
            );
        }
    }

    return OpsNav;
};

module.exports = initComponent;
